import React, { useState } from 'react'
import Button from '../../../components/CustomButtons/ButtonTS';
import CardBody from '../../../components/Card/CardBody';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';
import { InputMask } from "primereact/inputmask";

interface IAccelerateNodeCardBodyProps {
    nodeID: number;
    updatedViaWebsiteAt: string;
    accelerate: (nodeID: number, updatedViaWebsiteAt: string, acceleratedUntil: string|null) => void;
    accelerationModeOn: boolean;
    acceleratedUntil: string;
    hideAlert: () => void;
}

export default function AccelerateNodeCardBody(props: IAccelerateNodeCardBodyProps) {
    const {
        nodeID,
        updatedViaWebsiteAt,
        accelerate,
        accelerationModeOn,
        acceleratedUntil
    } = props;
    const [blockButton, setBlockButton] = useState(false);
    const [minutes, setMinutes] = useState(0);
    return (
        <CardBody>
            <form>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                    <TextField
                            id='minutes'
                            label='Accelerate for'
                            inputProps={{
                                value: minutes,
                                maxLength: 4,
                                autoCapitalize: 'off',
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{"minutes"}</InputAdornment>,
                            }}
                            onChange={(e) => {
                                let value = parseInt(e.target.value);
                                if (Number.isNaN(value) || value == undefined) {
                                    value = 0
                                }
                                setMinutes(value);
                            }}
                        ></TextField>
                    </GridItem>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                        {accelerationModeOn ?
                        <Button
                            color='danger'
                            onClick={(e, value) => {
                                setBlockButton(true);
                                accelerate(nodeID, updatedViaWebsiteAt, null);
                                props.hideAlert();
                            }}
                            disabled={blockButton}
                            data-testid='accelerateButton'
                            style={{width: '45%'}}
                            className='downloadButton' >
                            Cancel acceleration
                        </Button>
                        : null}
                        <Button
                            color='info'
                            onClick={(e, value) => {
                                setBlockButton(true);
                                let newAcceleratedUntil: string|null = null;
                                const acceleratedUntilMillis = Date.parse(acceleratedUntil);
                                let newAcceleratedUntilMillis = Date.now() + minutes * 60 * 1000;
                                if (acceleratedUntil && acceleratedUntilMillis > Date.now()) {
                                  newAcceleratedUntilMillis = acceleratedUntilMillis + minutes * 60 * 1000;
                                }
                                newAcceleratedUntil = new Date(newAcceleratedUntilMillis).toISOString();
                                accelerate(nodeID, updatedViaWebsiteAt, newAcceleratedUntil);
                                props.hideAlert();
                            }}
                            disabled={blockButton}
                            data-testid='accelerateButton'
                            style={{width: '45%'}}
                            className='downloadButton' >
                            Accelerate
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>
        </CardBody >
    )
}
